import type { AiSideEffects, MemoryConfig } from '@timelyapp/integration-cloud-api-spec';

export type CoerceMemoryConfigSideEffectsReturn = {
  memoryConfig: MemoryConfig;
  /** Any side effects the coercion should result in, e.g refresh AI model */
  sideEffects: AiSideEffects;
};

export const coerceMemoryConfigSideEffects = (
  _config: MemoryConfig,
  existingConfig?: MemoryConfig
): CoerceMemoryConfigSideEffectsReturn => {
  const memoryConfig = {
    ..._config,
    // If summaries are getting off, force other memories to show.
    showOtherMemoriesLane: _config.minutesPerBlock === 0 ? true : _config.showOtherMemoriesLane,
  };

  // Determine possible side-effects
  let aiModelMustBeRetrained = false;
  if (existingConfig) {
    const changeComparison = { previous: existingConfig, current: memoryConfig };
    aiModelMustBeRetrained =
      _hasChanged('pxPerMinute', changeComparison) ||
      _hasChanged('minutesPerBlock', changeComparison) ||
      _hasChanged('groupMemoriesBy', changeComparison) ||
      _hasChanged('mergeWithinMinutes', changeComparison) ||
      _hasChanged('minimumGroupDurationMinutes', changeComparison);
  }

  return {
    memoryConfig,
    sideEffects: {
      aiModelMustBeRetrained,
      aiSuggestionsMustBeRefreshed: false,
    },
  };
};

/** Check if a preference property has changed value */
const _hasChanged = (
  property: keyof MemoryConfig,
  comparisons: {
    previous: MemoryConfig;
    current: MemoryConfig;
  }
): boolean => {
  return comparisons.previous?.[property] !== comparisons.current?.[property];
};
